<template>
  <div id="demo">
    <big-button :click="picker">picker</big-button>
    <big-button :click="clickit">modal</big-button>
    <big-button :click="tips">toast</big-button>
    <big-button :click="selectAddress">地址插件</big-button>
    <date-picker></date-picker>
    <div class="lists">
      <div class="list" v-for="(item, index) in list" :key="index">
        <span>{{item.data}}</span>
        <span>{{item.number}}</span>
      </div>
    </div>
    <address-alert :callback="getAddress" v-if="alertBoxShow"></address-alert>
  </div>
</template>

<script>
export default {
  name: "demo",
  data() {
    return {
      list: [
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'},
        {data: '2018-12-29' ,number: '2312'}
      ],
      show: false,
      price: '800'
    };
  },
  computed: {
    withBottomScroll() {
      return this.$store.state.onscroll.withBottom;
    },
    showDate() {
      if (!this.$store.state.date.config.selectResult[1]) {
        return (
          this.$store.state.date.config.default[1][0] +
          "-" +
          this.$store.state.date.config.default[1][1]
        );
      } else {
        return (
          this.$store.state.date.config.selectResult[0] +
          "-" +
          this.$store.state.date.config.selectResult[1]
        );
      }
    },
    alertBoxShow () {
      return this.$store.state.addressAlert;
    }
  },
  watch: {
    withBottomScroll () {
      if (this.withBottomScroll < 50) {
        this.addList();
      }
    },
    showDate() {
      console.log(this.showDate);
    }
  },
  beforeDestroy() {
    this.hideModal();
    this.$store.commit("beDefault", {});
    this.$store.commit('addressAlertChange', false);
  },
  methods: {
    addList() {
      this.list.push({data: '2018-12-29' ,number: '23122'}, {data: '2018-12-29' ,number: '23122'}, {data: '2018-12-29' ,number: '23122'}, {data: '2018-12-29' ,number: '23122'});
    },
    clickit() {
      this.Modal('提示', "确定要删除选中的商品吗？", ["取消","确定"], () => {
        console.log("确定");
      });
    },
    // 选择地址
    selectAddress() {
      this.$store.commit('addressAlertChange', true);
    },
    getAddress(adds) {
      console.log(adds[0] + ' ' + adds[1] + ' ' + adds[2]);
      this.$store.commit('addressAlertChange', false);
    },
    submit() {
      this.Toast(this.$store.state.password.password);
    },
    tips() {
      this.Toast("11");
    },
    picker() {
      this.$store.commit("configDateWrap");
    },
    onShowPay () {
      this.$store.commit('showPassword', () => { console.log(this.$store.state.password.password) });
    },
    // 密码输入完成回调
    inputEnd (val) {
        setTimeout(() => {
            // 模拟支付成功的结果
            if (val == 111111) {
                // 调用插件的$success方法告知插件支付成功
                // 并且在then方法里面可以写支付成功的回调，例如可以跳转支付结果页面
                this.$refs.pays.$success().then(res => {
                    console.log('支付成功')
                    this.$router.push('/success')
                })
            // 模拟支付失败的结果
            } else {
                this.$refs.pays.$fail()
            }
        }, 1000)
    },
    // 取消支付弹窗关闭的回调
    close() {
        console.log('关闭')
    },
    // 忘记密码跳转
    forget () {
        console.log('触发forge事件');
    }
  }
};
</script>
<style lang="scss">
#demo {
  padding-top: 100px;
  .lists{
    padding: 0 30px;
    background: #fff;
    .list{
      display: flex;
      justify-content: space-between;
      line-height: 120px;
    }
  }
}
</style>
